import { Component, OnInit, Input, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { TaskOrderExtras } from './taskorderextras';
import { TaskOrderExtraService } from './taskorderextras.service';
import { KindBoard } from 'src/utils/enums';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-taskorderextras',
    templateUrl: './taskorderextras.component.html',
    styleUrls: ['./taskorderextras.component.css'],
    standalone: false
})
export class TaskOrderExtrasComponent extends PageBase implements OnInit, OnChanges {

  @Input() taskitem: TaskItem;
  isHideLoading = true;
  taskOrderExtra: TaskOrderExtras = new TaskOrderExtras();
  Kind = KindBoard.Tarefa;

  constructor(private taskOrderService: TaskOrderExtraService,
              public ObjInjector: Injector)
  {
    super(ObjInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.taskOrderExtra.balancevalue = this.taskOrderExtra.id = this.taskOrderExtra.orderextradelivered = this.taskOrderExtra.orderextrapaid
    = this.taskOrderExtra.orderextravalue = this.taskOrderExtra.percentage = 0;
    this.taskitem = new TaskItem();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskitem) {
      this.isHideLoading = false;
      this.load();
    }
  }

  async load() {
    if(this.contextApplication.currentVision == KindBoard.Tarefa.valueOf()) {
      this.taskOrderExtra = await this.taskOrderService.GetTaskOrderExtra(this.taskitem);
    }
    else {
      this.taskOrderExtra = await this.taskOrderService.GetTaskOrderExtraByInput(this.taskitem);
    }
    this.isHideLoading = true;
  }

  onReceiveLiterals() {}
}
